
<template>
  <div id="action-box">
    <v-sheet rounded>
      <div class="dhivehiHeading text-center dhivehi">
        ޙަވާލުކުރެވިފައިވާ  މަސައްކަތްތައް <br />
        <span v-if="selectedActions" class="text-sm dhivehi">
          ޖުމުލަ {{ selectedActions.total ? selectedActions.total : 0 }}</span
        >
      </div>

      <div class="text-center" v-if="selectedActions">
        <v-chip
          v-if="selectedActions.entry_status"
          color="blue"
          dark
          outlined
          small
          @click="filterList('entry_actions')"
        >
          {{ selectedActions.entry_status.pending }} /
          {{ selectedActions.entry_status.completed }}
          <span class="english px-2">Entry Actions</span>
        </v-chip>

        <v-chip
          v-if="selectedActions.task_status"
          class="ma-2"
          color="green darken-4 english"
          dark
          outlined
          small
          @click="filterList('tasks')"
        >
          Tasks {{ selectedActions.task_status.pending }} /
          {{ selectedActions.task_status.completed }}
        </v-chip>
        <!--                
                    <date-picker  v-model="filter.filterDate" type="date" range lang="en"  
                          value-type="YYYY-MM-DD"  style="width: 60%;" ></date-picker> -->
        <v-btn
          x-small
          outlined
          color="black"
          class="english"
          @click="filterList('date')"
          >Filter</v-btn
        >
        <v-btn
          v-if="
            filter.filterModel ||
            (filter.filterDate && filter.filterDate[0] != null)
          "
          x-small
          outlined
          color="red"
          class="english"
          @click="resetFilters()"
          >Clear all</v-btn
        >
        <!-- <v-btn x-small outlined color="green" class="english" @click="$route.query.page = 1, loadItems()">Filter</v-btn> -->
      </div>

      <v-simple-table dense class="table table-striped dhivehi mt-5">
        <thead>
          <tr>
            <th style="width: 200px">ރެފަރެންސް #</th>
            <th style="width: 100px">ހަވާލުކުރި ތާރީޚް</th>
            <th style="width: 150px">ހަމަވާ ތާރީޚް</th>
            <th style="width: 150px">ނިމުނު ތާރީޚް</th>
            <th style="width: 50px"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            dense
            v-for="(item, index) in selectedActions.list"
            :key="index"
            :class="item.decision == 'appeal' ? 'tr-appeal' : null"
          >
            <td class="english text-center">
              <v-chip
                class="ml-2"
                x-small
                :color="item.model == 'Task' ? 'green darken-4 ' : 'blue'"
                pill
                outlined
              >
                {{
                  item.reference_number ? item.reference_number : item.ref_num
                }}</v-chip
              >
            </td>
            <td class="english text-center">
              <span class="text-sm">
                {{
                  item.assigned_at
                    ? new Date(item.assigned_at).toLocaleDateString("en-GB")
                    : ""
                }}
              </span>
            </td>
            <td class="english text-center">
              <span class="text-sm">
                {{
                  item.assigned_at
                    ? new Date(item.date_due).toLocaleDateString("en-GB")
                    : ""
                }}
              </span>
            </td>
            <td class="english text-center">
              <span class="text-sm" v-if="item.status == 'completed'"
                >{{
                  item.last_updated
                    ? new Date(item.last_updated).toLocaleDateString("en-GB")
                    : ""
                }}
              </span>
            </td>
            <td class="english text-center">
              <v-chip
                dark
                x-small
                class="float-left text-uppercase english"
                color="blue"
                >{{ item.status }}</v-chip
              >
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "pending-leave",
  data() {
    return {
      isLoading: false,
      selectedActions: "",
      filter: {
        filterModel: "",
        filterDate: [null, null],
      },
    };
  },

  props: ["selectedUser"],

  watch: {
    selectedUser(value) {
      console.log(value);
      if (value) {
        this.getUserActions();
      }
    },
  },

  methods: {
    open() {
      this.getUserActions();
    },

    filterList(type) {
      this.filter.filterModel = type;
      this.getUserActions();
    },

    getUserActions() {
      let requestParams = {};

      this.filter.filterModel
        ? (requestParams.filter_type = this.filter.filterModel)
        : delete requestParams.filter_type;
      this.filter.filterDate[0]
        ? (requestParams.filter_date = this.filter.filterDate)
        : delete requestParams.filter_date;
      return this.$axios
        .get(`/api/leave-request/${this.selectedUser}/pending-works`, {
          params: requestParams,
        })
        .then((resp) => {
          this.selectedActions = resp.data;
        });
    },
    resetFilters() {
      Object.assign(this.$data.filter, this.$options.data().filter);
      this.getUserActions();
    },
  },
};
</script>

<style scoped>
#action-box {
  width: 100%;
  /* margin-right: 8px; */
  max-height: 500px;
  overflow-y: auto;
  /* padding: 0.3rem; */
  scrollbar-gutter: stable;
}

.text-sm {
  font-size: 0.8rem;
}
.v-data-table.table.table-striped.dhivehi.mt-5.v-data-table--dense.theme--light {
  box-shadow: inset 0 0 6px rgba(168, 167, 167, 0.3);
}
</style>

